import { ReactNode } from 'react';

const AlertTypeValues = {
  Default: 'default',
  Alert: 'alert',
} as const;

type AlertType = typeof AlertTypeValues[keyof typeof AlertTypeValues];

export default interface AlertCardProps {
  className?: string;
  heading: string;
  children?: string | ReactNode;
  type?: AlertType;
}
export { AlertTypeValues, AlertType };
